module.exports = __webpack_public_path__ + "sites@2x--535fa98f.jpg";


//////////////////
// WEBPACK FOOTER
// ./_source/img/sites/sites@2x.jpg
// module id = 133
// module chunks = 0